// @flow
import * as React from "react"
import { hot } from "react-hot-loader"
import { Video } from "../../components/Video"
import { Grid123 } from "../../components/FlexibleContent/Grid123"
import { setHtml } from "../../utils"
import { tRouteProps, tVideoArchivesTemplate } from "../../types"
import { Container } from "../../components/StyledComponents"
import { css } from "emotion/macro"
import { PageMeta } from "../../components/PageMeta"

type tVideo = {
  video: string,
  thumbnail: {
    url: string
  },
  caption: string
}

export function VideoArchives(props: tVideoArchivesTemplate & tRouteProps) {
  return (
    <Container
      className={css`
        .caption {
          font-size: 14px;
          lin-height: 1.125;
          background-color: #f2f2f2;
          padding: 10px;
        }
      `}
    >
      <PageMeta title={props.title} description="" image={props.brand.logo} />
      <div
        className={css`
          margin-bottom: -30px;
          .video {
            &,
            .video-toggle,
            img {
              width: 100%;
            }
          }
        `}
      >
        {props.watch_template_content.videos.length > 0 && (
          <Grid123
            title="Watch Anytime"
            items={props.watch_template_content.videos.map(
              ({ video, thumbnail, caption }) => (
                <React.Fragment key={thumbnail.url}>
                  <Video
                    className="video"
                    style={{}}
                    video={video}
                    thumbnail={thumbnail.url}
                  />

                  {caption && <div className="caption">{caption}</div>}
                </React.Fragment>
              )
            )}
          />
        )}
      </div>
      {props.watch_template_content.footer_content && (
        <div {...setHtml(props.watch_template_content.footer_content)} />
      )}
    </Container>
  )
}

export default hot(module)(VideoArchives)



// WEBPACK FOOTER //
// /opt/build/repo/src/screens/Page/VideoArchives.js